/* ==========================================================================
   NaturoTheke — Mengenstaffel in der Buy-Box

   Ersetzt das fruehere Popup: das Angebot steht dauerhaft sichtbar ueber dem
   Warenkorb-Button, statt erst beim Klick aufzutauchen.

   Aufgabe des Skripts: die gewaehlte Stufe in das Mengenfeld des Produkt-
   formulars schreiben und die Ersparnis in Euro ausrechnen. Der Rabatt
   selbst kommt aus einem automatischen Rabatt im Shopify-Admin — Theme-Code
   kann keine Preise reduzieren.
   ========================================================================== */

(function () {
  'use strict';

  if (!window.customElements || customElements.get('naturo-qty-tiers')) return;

  customElements.define(
    'naturo-qty-tiers',
    class NaturoQtyTiers extends HTMLElement {
      connectedCallback() {
        this.options = Array.from(this.querySelectorAll('[data-nqt-option]'));
        if (!this.options.length) return;

        this.currentEl = this.querySelector('[data-nqt-current]');
        this.barEl = this.querySelector('[data-nqt-bar]');
        this.currency = this.dataset.nqtCurrency || '€';
        this.prices = this.parsePrices(this.dataset.nqtPrices);
        // Groesste lieferbare Stufe je Variante (-1 = unbegrenzt). Kommt aus
        // Liquid, weil Shopify zu grosse Mengen sonst still kuerzt.
        this.caps = this.parsePrices(this.dataset.nqtCaps);

        this.form = this.closest('form') || this.closest('product-form form');
        if (!this.form) {
          // Der Block kann ausserhalb des Formulars sitzen (Dawn rendert die
          // Buy-Box je nach Vorlage unterschiedlich). Dann ueber die Section
          // suchen statt aufzugeben.
          var section = this.closest('.shopify-section') || document;
          this.form = section.querySelector('product-form form');
        }

        this.hideDefaultQuantity();
        this.bindOptions();
        this.bindVariantChange();
        this.select(this.options[0], { silent: true });
      }

      /* Die normale Mengenauswahl steht in der Buy-Box meist VOR der Staffel.
         Ein Geschwister-Selektor in CSS greift deshalb nicht — hier per JS,
         damit die Reihenfolge der Bloecke egal ist. */
      hideDefaultQuantity() {
        if (!this.hasAttribute('data-nqt-hide-quantity')) return;
        var scope = this.closest('.shopify-section') || document;
        scope.querySelectorAll('.product-form__quantity').forEach(function (el) {
          el.hidden = true;
        });
      }

      /* Liquid liefert "id:preis,id:preis" — kompakter als ein JSON-Attribut
         und robust gegen Anfuehrungszeichen im HTML. */
      parsePrices(raw) {
        var map = {};
        (raw || '').split(',').forEach(function (pair) {
          var parts = pair.split(':');
          if (parts.length === 2) map[parts[0].trim()] = parseInt(parts[1], 10) || 0;
        });
        return map;
      }

      currentPrice() {
        var idInput = this.form && this.form.querySelector('[name="id"]');
        var price = idInput ? this.prices[String(idInput.value).trim()] : null;
        if (price) return price;

        // Fallback: irgendeinen bekannten Preis nehmen, damit die Ersparnis
        // nicht auf 0 faellt, wenn die Variante (noch) nicht im Formular steht.
        var values = Object.keys(this.prices).map((k) => this.prices[k]);
        return values.length ? values[0] : 0;
      }

      /* Groesste noch lieferbare Stufe der gewaehlten Variante; -1 = unbegrenzt. */
      currentCap() {
        var idInput = this.form && this.form.querySelector('[name="id"]');
        var id = idInput ? String(idInput.value).trim() : '';
        return Object.prototype.hasOwnProperty.call(this.caps || {}, id) ? this.caps[id] : -1;
      }

      money(cents) {
        return (cents / 100).toFixed(2).replace('.', ',') + ' ' + this.currency;
      }

      bindOptions() {
        this.options.forEach((option) => {
          option.addEventListener('click', (event) => {
            // Das Label umschliesst das Radio; ohne das hier zaehlt der Klick
            // doppelt und die Auswahl springt zurueck.
            if (event.target.tagName !== 'INPUT') event.preventDefault();
            this.select(option);
          });

          option.addEventListener('keydown', (event) => {
            if (event.code === 'Space' || event.code === 'Enter') {
              event.preventDefault();
              this.select(option);
            }
          });
        });
      }

      /* Bei einem Variantenwechsel baut Dawn die Buy-Box neu auf: [name="id"]
         wechselt, und das Mengenfeld wird ersetzt. Ohne Nachfassen zeigt die
         Staffel dann "5 Stueck", legt aber nur 1 Stueck in den Warenkorb.
         Dawn meldet das Ende des Nachladens nicht per DOM-Event, deshalb
         zweimal zeitversetzt statt einmal sofort.

         WICHTIG: Die Variantenauswahl liegt NICHT im Formular — Dawn haengt
         sie ueber das form-Attribut an. Ein Listener am Formular sieht diese
         Wechsel also nie; wir muessen an den Auswahl-Elementen selbst horchen. */
      bindVariantChange() {
        var scope = this.closest('.shopify-section') || document;
        var pickers = scope.querySelectorAll('variant-radios, variant-selects');
        pickers.forEach((picker) => {
          picker.addEventListener('change', () => this.scheduleReapply());
        });

        if (this.form) {
          this.form.addEventListener('change', (event) => {
            if (this.suppressChange) return;
            if (event.target && event.target.closest('[data-nqt-option]')) return;
            if (event.target === this.hiddenQty) return;
            this.scheduleReapply();
          });
        }
      }

      /* Nur EIN Paar Nachfass-Timer gleichzeitig. Vorher plante jeder Durchlauf
         zwei weitere, und weil writeQuantity() selbst ein change-Event
         ausloest, hat sich das exponentiell hochgeschaukelt bis der Browser
         stand — der Warenkorb-Button reagierte dann nicht mehr. */
      scheduleReapply() {
        clearTimeout(this.timerA);
        clearTimeout(this.timerB);
        this.timerA = setTimeout(() => this.reapply(), 250);
        this.timerB = setTimeout(() => this.reapply(), 900);
      }

      /* Auswahl erneut durchsetzen, nachdem Dawn die Buy-Box neu gebaut hat. */
      reapply() {
        if (!this.active) return;
        this.hideDefaultQuantity();

        // Neue Variante hat weniger auf Lager als die gewaehlte Stufe? Dann auf
        // die groesste Stufe zurueckfallen, die noch geht — sonst kuerzt
        // Shopify still und der Kunde verliert den Rabatt ohne Hinweis.
        var cap = this.currentCap();
        if (cap >= 0 && (parseInt(this.active.dataset.nqtQty, 10) || 1) > cap) {
          var passend = this.options.filter((o) => (parseInt(o.dataset.nqtQty, 10) || 0) <= cap).pop();
          if (passend) {
            this.select(passend, { silent: true, force: true });
            return;
          }
        }

        this.writeQuantity(parseInt(this.active.dataset.nqtQty, 10) || 1);
        this.update();
      }

      select(option, opts) {
        // Gesperrte Stufe (zu wenig auf Lager) laesst sich nicht waehlen.
        if (option.classList.contains('is-unavailable') && !(opts && opts.force)) return;

        this.options.forEach((o) => {
          var active = o === option;
          o.classList.toggle('is-active', active);
          var radio = o.querySelector('.nqt__radio');
          if (radio) radio.checked = active;
        });

        this.active = option;
        this.writeQuantity(parseInt(option.dataset.nqtQty, 10) || 1);
        this.update();

        if (!opts || !opts.silent) {
          this.dispatchEvent(new CustomEvent('naturo:tier-change', { bubbles: true }));
        }
      }

      /* Die Menge muss im Formular landen, sonst legt Dawn nur 1 Stueck in den
         Warenkorb. Gibt es kein sichtbares Mengenfeld, legen wir eins an. */
      writeQuantity(qty) {
        if (!this.form) return;

        // Bewusst nur innerhalb des Produktformulars suchen: auf der Seite gibt
        // es weitere Mengenfelder (Warenkorb-Schublade, Schnellkauf).
        var input = this.form.querySelector('[name="quantity"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'quantity';
          this.form.appendChild(input);
        }

        this.hiddenQty = input;
        input.value = qty;

        // Dawns quantity-input haengt an "change"; ohne das Event bleibt eine
        // sichtbare Mengenauswahl auf dem alten Wert stehen. Das Event ist
        // aber unser eigenes und darf nicht wieder bei uns landen — sonst
        // planen wir daraufhin erneut ein reapply(), und das schaukelt sich
        // hoch, bis die Seite steht.
        this.suppressChange = true;
        try {
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } finally {
          this.suppressChange = false;
        }
      }

      update() {
        if (!this.active) return;

        var price = this.currentPrice();
        var index = this.options.indexOf(this.active);

        if (this.currentEl) {
          this.currentEl.textContent = this.active.dataset.nqtQty;
        }

        if (this.barEl) {
          this.barEl.style.width = ((index + 1) / this.options.length) * 100 + '%';
        }

        // Euro-Ersparnis je Stufe ueber der Stufe anzeigen. Fester Betrag gilt
        // fuer die ganze Stufe und haengt nicht vom Preis ab; Prozent wird aus
        // dem Preis der gewaehlten Variante gerechnet.
        var word = this.dataset.nqtSaveWord || 'Spare';
        var cap = this.currentCap();
        this.options.forEach((option, i) => {
          var pct = parseFloat(option.dataset.nqtPct) || 0;
          var fixed = parseInt(option.dataset.nqtFixed, 10) || 0;
          var qty = parseInt(option.dataset.nqtQty, 10) || 0;

          // Stufe sperren, wenn die Variante so viele Stueck nicht hergibt.
          var tooMany = cap >= 0 && qty > cap;
          option.classList.toggle('is-unavailable', tooMany);
          option.setAttribute('aria-disabled', tooMany ? 'true' : 'false');
          var radio = option.querySelector('.nqt__radio');
          if (radio) radio.disabled = tooMany;
          var stockNote = option.querySelector('[data-nqt-stock]');
          if (stockNote) stockNote.hidden = !tooMany;
          var hint = this.querySelector('[data-nqt-hint="' + (i + 1) + '"]');
          if (!hint) return;

          var saving = fixed > 0 ? fixed : (pct > 0 && price > 0 ? Math.round(price * qty * (pct / 100)) : 0);
          if (saving > 0 && !tooMany) {
            hint.textContent = word + ' ' + this.money(saving);
            hint.hidden = false;
          } else {
            hint.hidden = true;
          }
        });
      }
    }
  );
})();
